import React, { useEffect, useState, useRef } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { connect } from "react-redux"
import { mapDispatchProps, mapStateToProps } from "../../store/store"

import API from "../../api"
import { ROUTES } from "../../routes"

import LoadingText from "components/loadingText"
import PostingCard from "components/postingCard"



const PostingShow = (props: any) => {
  const navigate = useNavigate()
  const params = useParams()

  const [isFetching, setIsFetching] = useState<boolean>(false)
  const [posting, setPosting] = useState<any>(null)

  useEffect(() => {
    const parsed = parseInt(params?.id, 10);
    if (!isNaN(parsed) && Number.isInteger(parsed)) {
      fetchPosting(params.id)
    }
  }, [])

  async function fetchPosting (postingId:string) {
    setIsFetching(true)
    API.Post.show({
      brandToken: props.auth.token,
      postingId: postingId
    })
      .then((response: any) => {
        console.log('response.data.posting.products', response.data.posting.products)
        // Model 자체에서 products 순서를 뒤집어놨는데 이유를 알 수 없음.
        // 엮인 곳이 많다보니 사이드이펙트가 우려되서 클라이언트단에서 해결
        // if (response?.data?.posting?.products != null) {
        //   response.data.posting.products = response.data.posting.products.reverse()
        // }
        setPosting(response.data.posting)
      })
      .catch((error) => {
        props.showModal({
          hideCloseButton: true,
          text: error.message,
          confirm: () => {
            navigate(ROUTES.AUTH_INDEX.PATH);
          }
        })
      })
      .finally(() => {
        setIsFetching(false)
      })
  }

  return (
    <>
      {isFetching && (
        <div
          className="fixed top-0 w-full h-full flex items-center justify-center z-[1]"
          style={{ backgroundColor: "rgb(148 163 184 / 0.5)" }}
        >
          <LoadingText
            text={"Loading"}
            render={(text) => (
              <div className="w-[180px] rounded-full p-2 text-center text-3xl font-bold text-white select-none">
                {text}
              </div>
            )}
          />
        </div>
      )}

      <div className="py-10 flex flex-col justify-center items-center">
        {(posting != null) && (
          <PostingCard
            className="p-5 border rounded-md gap-5"
            isPopup={true}
            style={{
              width: "80dvw",
              maxWidth: "1500px",
              overflow: "scroll",
            }}
            posting={posting}
            showFeedbacks={false}
            // isShoes={product.current ? product.current.isShoes : null}
            // isUnderwear={product.current ? product.current.isUnderwear : null}
            onUpdate={(posting?: any) => {
              setPosting(posting)
            }}
            onLike={(userId: number, result: any) => {
              // const postingsCopy = [...postings].map((item) =>
              //   item.userId == userId
              //     ? {
              //         ...item,
              //         ...{
              //           likes: result ? [true] : [],
              //         },
              //       }
              //     : item
              // )

              setPosting((posting) => {
                return {
                  ...posting,
                  ...{
                    likes: result ? [true]: [],
                  }
                };
              })
            }}
            onSearch={(params: any) => {
              navigate(ROUTES.POSTING_INDEX.PATH, {
                state: {
                  ...params,
                },
              })
            }}
          />
        )}
      </div>
    </>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(PostingShow)